/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { ProductAssortmentGroupData } from './ProductAssortmentGroupData';
import {
    ProductAssortmentGroupDataFromJSON,
    ProductAssortmentGroupDataFromJSONTyped,
    ProductAssortmentGroupDataToJSON,
    ProductAssortmentGroupDataToJSONTyped,
} from './ProductAssortmentGroupData';

/**
 * 
 * @export
 * @interface ProductAssortmentSummaryData
 */
export interface ProductAssortmentSummaryData {
    /**
     * Number of product identities in the full filtered source population, including zero and negative values.
     * @type {number}
     * @memberof ProductAssortmentSummaryData
     */
    sourceTotalItems?: number;
    /**
     * Number of products eligible for ABC classification using abcMetric.
     * @type {number}
     * @memberof ProductAssortmentSummaryData
     */
    classifiedItems?: number;
    /**
     * Legacy positive-only ABC base total in the units named by abcMetric. Use turnover for signed product revenue.
     * @type {number}
     * @memberof ProductAssortmentSummaryData
     */
    totalValue?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductAssortmentSummaryData
     */
    turnover?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductAssortmentSummaryData
     */
    positiveTurnover?: MoneyOutput;
    /**
     * Number of product identities with positive turnover, eligible for the positive-only turnover base.
     * @type {number}
     * @memberof ProductAssortmentSummaryData
     */
    turnoverPositiveItems?: number;
    /**
     * Metric used by the legacy positive-only ABC totalValue and group shares.
     * @type {ProductAssortmentSummaryDataAbcMetricEnum}
     * @memberof ProductAssortmentSummaryData
     */
    abcMetric?: ProductAssortmentSummaryDataAbcMetricEnum;
    /**
     * 
     * @type {Array<ProductAssortmentGroupData>}
     * @memberof ProductAssortmentSummaryData
     */
    groups?: Array<ProductAssortmentGroupData>;
}


/**
 * @export
 */
export const ProductAssortmentSummaryDataAbcMetricEnum = {
    Amount: 'amount',
    Turnover: 'turnover'
} as const;
export type ProductAssortmentSummaryDataAbcMetricEnum = typeof ProductAssortmentSummaryDataAbcMetricEnum[keyof typeof ProductAssortmentSummaryDataAbcMetricEnum];


/**
 * Check if a given object implements the ProductAssortmentSummaryData interface.
 */
export function instanceOfProductAssortmentSummaryData(value: object): value is ProductAssortmentSummaryData {
    return true;
}

export function ProductAssortmentSummaryDataFromJSON(json: any): ProductAssortmentSummaryData {
    return ProductAssortmentSummaryDataFromJSONTyped(json, false);
}

export function ProductAssortmentSummaryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAssortmentSummaryData {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceTotalItems': json['sourceTotalItems'] == null ? undefined : json['sourceTotalItems'],
        'classifiedItems': json['classifiedItems'] == null ? undefined : json['classifiedItems'],
        'totalValue': json['totalValue'] == null ? undefined : json['totalValue'],
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
        'positiveTurnover': json['positiveTurnover'] == null ? undefined : MoneyOutputFromJSON(json['positiveTurnover']),
        'turnoverPositiveItems': json['turnoverPositiveItems'] == null ? undefined : json['turnoverPositiveItems'],
        'abcMetric': json['abcMetric'] == null ? undefined : json['abcMetric'],
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(ProductAssortmentGroupDataFromJSON)),
    };
}

export function ProductAssortmentSummaryDataToJSON(json: any): ProductAssortmentSummaryData {
    return ProductAssortmentSummaryDataToJSONTyped(json, false);
}

export function ProductAssortmentSummaryDataToJSONTyped(value?: ProductAssortmentSummaryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceTotalItems': value['sourceTotalItems'],
        'classifiedItems': value['classifiedItems'],
        'totalValue': value['totalValue'],
        'turnover': MoneyOutputToJSON(value['turnover']),
        'positiveTurnover': MoneyOutputToJSON(value['positiveTurnover']),
        'turnoverPositiveItems': value['turnoverPositiveItems'],
        'abcMetric': value['abcMetric'],
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(ProductAssortmentGroupDataToJSON)),
    };
}

